import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import { ProjectTeamInvitationList } from "features/project-team/ui/project-team-invitation-list/ProjectTeamInvitationList"
import { ProjectTeamInvitationListModel } from "features/project-team/ui/project-team-invitation-list/types/ProjectTeamInvitationListModel"

import "../styles/_project-team-invitation-list-overlay.scss"

export const PROJECT_TEAM_INVITATION_LIST_OVERLAY_ID =
  "project-team-invitation-list-overlay"

export interface ProjectTeamInvitationListOverlayViewProps
  extends WithClassName {
  projectTeamInvitationListModel: ProjectTeamInvitationListModel
  onClose: () => void
}

export const ProjectTeamInvitationListOverlayView = React.memo(
  ({
    className,
    projectTeamInvitationListModel,
    onClose
  }: ProjectTeamInvitationListOverlayViewProps) => {
    const { t } = useTranslation()
    return (
      <OverlayWrapper
        id={PROJECT_TEAM_INVITATION_LIST_OVERLAY_ID}
        classNamePrefix={PROJECT_TEAM_INVITATION_LIST_OVERLAY_ID}
        className={classNames(
          PROJECT_TEAM_INVITATION_LIST_OVERLAY_ID,
          className
        )}
        mobileFullscreen
      >
        <OverlayHeader.Container>
          <OverlayHeader.Title>
            {t("Team.Invitation.List.OverlayTitle")}
          </OverlayHeader.Title>
          <OverlayHeader.CloseButton onClick={onClose} className="primary" />
        </OverlayHeader.Container>
        <div className="project-team-invitation-list-overlay__content">
          <ProjectTeamInvitationList {...projectTeamInvitationListModel} />
        </div>
      </OverlayWrapper>
    )
  }
)
